import React from 'react';
import { Trophy } from 'lucide-react';

interface ContestStatusCardProps {
  isEnded: boolean;
  lastUpdated?: Date;
}

export default function ContestStatusCard({ isEnded, lastUpdated }: ContestStatusCardProps) {
  return (
    <div className={`p-4 rounded-lg ${isEnded ? 'bg-red-50' : 'bg-green-50'}`}>
      <div className="flex items-center mb-2">
        <Trophy className={`h-5 w-5 mr-2 ${isEnded ? 'text-red-600' : 'text-green-600'}`} />
        <p className={`text-lg font-medium ${isEnded ? 'text-red-700' : 'text-green-700'}`}>
          {isEnded ? 'El concurso ha finalizado' : 'El concurso está activo'}
        </p>
      </div>
      <p className={`text-sm ${isEnded ? 'text-red-600' : 'text-green-600'}`}>
        {isEnded 
          ? 'La votación está deshabilitada y no se pueden realizar más votos.' 
          : 'Los usuarios pueden votar por sus árboles favoritos.'}
      </p>
      {lastUpdated && (
        <p className="text-xs text-gray-500 mt-2">
          Última actualización: {lastUpdated.toLocaleString()}
        </p>
      )}
    </div>
  );
}